import React from 'react';
import { SVGIcon } from '@/components/SVGIcon/SVGIcon';
import { APP_COLORS } from '@/config/colors';
import { IconName } from '../SVGIcon';

export interface SectionNoDataProps {
  title?: string;
  description?: string;
  icon?: 'info' | 'warning' | 'clock';
}

export const SectionNoData: React.FC<SectionNoDataProps> = ({
  title = 'Dane w przygotowaniu',
  description = 'Ta sekcja raportu jest obecnie w trakcie opracowywania przez rzeczoznawcę.',
  icon = 'clock',
}) => {
  const iconName = icon === 'info' ? 'i' : icon === 'warning' ? 'warning' : 'clock';
  const bgColor = icon === 'warning' ? 'bg-yellow-50' : 'bg-gray-50';
  const borderColor = icon === 'warning' ? 'border-yellow-200' : 'border-gray-200';

  return (
    <div className={`p-6 rounded-xl border ${bgColor} ${borderColor}`}>
      <div className="flex gap-4 items-start">
        <div className="flex-shrink-0 mt-0.5">
          <SVGIcon
            name={iconName as IconName}
            width={24}
            height={24}
          />
        </div>
        <div className="flex flex-col gap-1">
          <p className="text-base font-semibold text-text-primary">
            {title}
          </p>
          <p className="text-sm text-gray-500">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SectionNoData;
